/* eslint-disable import/prefer-default-export */
import * as yup from "yup";

const DesignOverviewSchema = yup.object().shape({
  description: yup
    .string()
    .min(20)
    .required(),
});

const OrderQuantitySchema = yup.object().shape({
  quantity: yup.string().required(),
});

const OrderPrintTypeSchema = yup.object().shape({
  printType: yup.string().required(),
});

const OrderDeadlineSchema = yup.object().shape({
  deadline: yup.string().required(),
});

const PersonalInfoSchema = yup.object().shape({
  name: yup.string().required(),
  email: yup
    .string()
    .email()
    .required(),
  university: yup.string(),
  organization: yup.string(),
});

export const buildForm = (onPrev, onNext, onSubmit) => [
  {
    name: "description",
    title: "Design Overview",
    description:
      "Describe in as much detail as possible what you'd like to have created.",
    schema: DesignOverviewSchema,
    handleNext: onNext,
    nextText: "Next",
    fields: [
      {
        name: "description",
        type: "textarea",
        placeholder:
          "This can include color, garment type, design ideas, or whatever else you think of.",
      },
    ],
  },
  {
    name: "deadline",
    title: "Deadline",
    description: "Do you have a deadline for your project?",
    schema: OrderDeadlineSchema,
    handleNext: onNext,
    handlePrev: onPrev,
    nextText: "Next",
    prevText: "Prev",
    fields: [
      {
        name: "deadline",
        type: "dropdown",
        options: [
          "Yes, less than a week",
          "Yes, 1-2 weeks",
          "Yes, more than 2 weeks",
          "No deadline",
        ],
      },
    ],
  },
  {
    name: "quantity",
    title: "Quantity",
    description: "Do you know how many pieces you'd like to order?",
    schema: OrderQuantitySchema,
    handleNext: onNext,
    handlePrev: onPrev,
    nextText: "Next",
    prevText: "Prev",
    fields: [
      {
        name: "quantity",
        type: "dropdown",
        options: ["10-30", "31-70", "71-150", "Over 150", "I'm not sure"],
      },
    ],
  },
  {
    name: "printType",
    title: "Print Type",
    description: "Do you know what print method you'd like to use?",
    schema: OrderPrintTypeSchema,
    handleNext: onNext,
    handlePrev: onPrev,
    nextText: "Next",
    prevText: "Prev",
    fields: [
      {
        name: "printType",
        type: "dropdown",
        options: [
          "Screen Print",
          "Direct to Garment (DTG)",
          "Embroidery",
          "I'm not sure",
        ],
      },
    ],
  },

  {
    name: "personalInfo",
    title: "Contact Info",
    description:
      "We may have some follow up questions to make sure that we understand exactly what you want to order.",
    schema: PersonalInfoSchema,
    handlePrev: onPrev,
    handleNext: onSubmit,
    prevText: "Prev",
    nextText: "Submit",
    fields: [
      {
        name: "name",
        displayName: "Name",
        autoComplete: "name",
        type: "textbox",
        placeholder: "Jane Doe",
      },
      {
        name: "email",
        displayName: "Email",
        autoComplete: "email",
        type: "textbox",
        placeholder: "jane@greekdressing.us",
      },
      {
        name: "university",
        displayName: "University (if applicable)",
        type: "textbox",
        placeholder: "University of Michigan",
      },
      {
        name: "organization",
        displayName: "Organization (if applicable)",
        type: "textbox",
        placeholder: "Alpha Phi",
      },
    ],
  },
];
